export default {
  masterSlave: {},
  isGlobalMode: false,
  clientToken: null
};
